import React, { useCallback } from 'react';
import styles from 'features/profile/index.module.scss';
import { CHANGE_EMAIL, useEmail, useEmailContext } from 'features/profile/use-email';
import { UPDATE_USER_INFO, useAppContext } from 'use-app';
import { EMAIL_EDIT_MODE } from 'features/profile/use-profile';
import TextInput from 'componets/text-input';
import Button from 'componets/button';
import analytics from 'service/analytics';

const ProfileEmail = React.forwardRef(({ email, inEditMode, onOpenEditMode, onCloseEditMode }, ref) => {
  const { dispatch: globalDispatch } = useAppContext();

  const onUpdateUserInfo = me => {
    globalDispatch({
      type: UPDATE_USER_INFO,
      payload: me,
    });
    onCloseEditMode();
  };

  const { dispatch, state, modifyEmail } = useEmail(email, onUpdateUserInfo);

  const changeModifyEmail = useCallback(
    value =>
      dispatch({
        type: CHANGE_EMAIL,
        payload: value,
      }),
    [dispatch]
  );

  const modifyEmailClick = () => {
    analytics.track('帳號資訊頁_帳號_修改電子郵件_儲存_click');
    modifyEmail();
  };

  const DisplayMail = () => {
    if (inEditMode) {
      return (
        <div className={`${styles.box} ${styles.inEditMode} ${styles.mobileEditState}`} ref={ref}>
          <form className={`${styles.boxInfo}`}>
            <div className={styles.boxTitle}>修改電子郵件</div>
            <TextInput
              type="email"
              inputmode="email"
              placeholder="輸入email"
              newText={state.modifyEmail || state.email}
              onKeyPressEnter={modifyEmailClick}
              errorMessage={state.error}
              onTextChange={changeModifyEmail}
              onFocus={() => analytics.track('帳號資訊頁_帳號_修改電子郵件_輸入_click')}
            />
            <div className={styles.boxButton}>
              <Button
                type="button"
                variant="text"
                onClick={() => {
                  analytics.track('帳號資訊頁_帳號_修改電子郵件_取消_click');
                  onCloseEditMode();
                }}
              >
                取消
              </Button>
              <Button type="submit" loading={state.loading} onClick={modifyEmailClick}>
                儲存
              </Button>
            </div>
          </form>
        </div>
      );
    } else {
      return (
        <div className={styles.box}>
          <div className={styles.boxInfo}>
            <div className={styles.boxTitle}>電子郵件</div>
            <div className={styles.boxContent}>{email}</div>
          </div>
          <div className={styles.boxEdit}>
            <span
              className={styles.edit}
              onClick={() => {
                analytics.track('帳號資訊頁_帳號_修改電子郵件_click');
                onOpenEditMode(EMAIL_EDIT_MODE);
              }}
            >
              修改
            </span>
          </div>
        </div>
      );
    }
  };

  return (
    <useEmailContext.Provider>
      <DisplayMail />
    </useEmailContext.Provider>
  );
});

export default ProfileEmail;
